export default __webpack_public_path__ + "static/media/logo.934fa85d.webp";